import { render, staticRenderFns } from "./StatisticsCompanyAndUserTypeBook.vue?vue&type=template&id=4e5b080e&scoped=true"
import script from "./StatisticsCompanyAndUserTypeBook.vue?vue&type=script&lang=ts"
export * from "./StatisticsCompanyAndUserTypeBook.vue?vue&type=script&lang=ts"
import style0 from "./StatisticsCompanyAndUserTypeBook.vue?vue&type=style&index=0&id=4e5b080e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5b080e",
  null
  
)

export default component.exports